import React from 'react';
import styled from 'styled-components';
import { CheckCircleOutlined } from '@ant-design/icons';

interface ConfirmedIconProps {
  $isTouched?: boolean;
}

const ConfirmedIcon = styled(CheckCircleOutlined)<ConfirmedIconProps>`
  color: ${(props) => (props.$isTouched ? '#faad14' : '#0b8235')};
`;

interface StatusIconProps {
  icon: React.ComponentType;
  isTouched?: boolean;
  isConfirmed?: boolean;
}

const StatusIcon = function ({
  icon: Icon,
  isConfirmed = false,
  isTouched = false,
}: StatusIconProps) {
  if (isConfirmed || isTouched) {
    return <ConfirmedIcon $isTouched={isTouched} />;
  }

  return <Icon />;
};

export default styled(StatusIcon)`
  vertical-align: 0;
`;
